import React, { useEffect, useState } from 'react'
import { Box, Typography, Link, makeStyles } from '@material-ui/core'
import { RiArrowLeftLine } from 'react-icons/ri'
import { useHistory } from 'react-router-dom'
import PasswordField from 'src/components/ui/PasswordField'
import { useForm } from 'react-hook-form'
import yup from '../../components/yupCustom'
import Swal from 'sweetalert2'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from 'src/components/ui/Button'
import Container from '@material-ui/core/Container'
//import api from 'src/core/services/api'
import { AlterarSenhaMaster as alterarSenhaMaster, hasMasterPassword } from 'src/api/auth'

const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  submit: {
    margin: theme.spacing(2, 0, 3)
  }
}))

export default function AlterarSenhaMaster() {
  const history = useHistory()
  const styles = useStyles()
  const [loading, setLoading] = useState(false)
  const [existeSenhaMaster, setExisteSenhaMaster] = useState<boolean | null>(null)

  const schema = yup.object().shape({
    senhaAtual: yup.string().when([], {
      is: () => existeSenhaMaster === true,
      then: schema => schema.required('Senha atual obrigatória').min(6).max(50),
      otherwise: schema => schema.notRequired()
    }),
    novaSenha: yup.string().min(6).required().label('Nova senha master'),
    confirmacaoNovaSenha: yup
      .string()
      .min(6)
      .required()
      .label('Confirmação da nova senha master')
      .test('passwords-match', 'Senhas estão diferentes', function (value) {
        return this.parent.novaSenha === value
      })
  })

  useEffect(() => {
    async function checkMasterPassword() {
      try {
        const resp = await hasMasterPassword()
        setExisteSenhaMaster(resp.data)
      } catch (err) {
        setExisteSenhaMaster(false)
      }
    }
    checkMasterPassword()
  }, [])

  const {
    errors,
    handleSubmit,
    register,
    watch
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: { senhaAtual: '', novaSenha: '', confirmacaoNovaSenha: '' }
  })

  const command = watch()

  async function onSubmit(body) {
    try {
        setLoading(true)
        await alterarSenhaMaster({
            CurrentPassword: body.senhaAtual,
            NewPassword: body.novaSenha
        })
        setLoading(false)
        await Swal.fire({
          title: 'Sucesso!',
          text: 'A nova senha master foi definida',
          icon: 'success',
          confirmButtonText: 'Ok'
        })
        history.push('/')
    } catch (err) {
        showNotificationErrorAPI(err)
        setLoading(false)
    }
  }

  if (existeSenhaMaster === null) {
    return (
      <Container maxWidth="xs" style={{ paddingTop: 30 }}>
        <Typography align="center">Carregando...</Typography>
      </Container>
    )
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      className="fadeInTransition syn-container-out"
      style={{ paddingTop: 30 }}
    >
      <Box className="syn-box-out">
        <div className={styles.paper}>
          <Link
            component="button"
            color="secondary"
            onClick={() => history.goBack()}
          >
            <RiArrowLeftLine />
            <Typography
              style={{ marginLeft: 10 }}
              variant="subtitle1"
              component="span"
            >
              Voltar
            </Typography>
          </Link>
          <Box my={3}>
            <Typography variant="h6">{existeSenhaMaster ? 'Alterar Senha Master' : 'Cadastrar Senha Master'}</Typography>
          </Box>
          <Typography variant="body1">Senha master do hospital.</Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            {existeSenhaMaster && (
              <PasswordField
                erro={errors}
                name="senhaAtual"
                label="Senha master atual"
                value={command.senhaAtual}
                inputRef={register}
              />
            )}

            <PasswordField
              erro={errors}
              name="novaSenha"
              label="Nova senha master"
              value={command.novaSenha}
              inputRef={register}
            />

            <PasswordField
              erro={errors}
              name="confirmacaoNovaSenha"
              label="Confirmar nova senha master"
              value={command.confirmacaoNovaSenha}
              inputRef={register}
            />

            <Button
              loading={loading}
              disabled={loading}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={styles.submit}
            >
              Definir senha master
            </Button>
          </form>
        </div>
      </Box>
    </Container>
  )
}
